import { axios } from "@/utils/request";

const config_api = {
  config: "/api/wechat/system/config",
};

export function getRuleText(customerId) {
    return axios({
        url: config_api.config+"/rule/"+customerId,
        method: 'get',
    })
}
  